var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddGrayTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6112_100700)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 29,
    height: 29,
    rx: 5,
    fill: "#8A8C89"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.375 10.8125C22.8237 10.8125 23.1875 11.1763 23.1875 11.625V21.375C23.1875 21.8237 22.8237 22.1875 22.375 22.1875H12.625C12.1763 22.1875 11.8125 21.8237 11.8125 21.375V11.625C11.8125 11.1763 12.1763 10.8125 12.625 10.8125H22.375ZM12.625 10C11.7275 10 11 10.7275 11 11.625V21.375C11 22.2725 11.7275 23 12.625 23H22.375C23.2725 23 24 22.2725 24 21.375V11.625C24 10.7275 23.2725 10 22.375 10H12.625Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13.25C17.7244 13.25 17.9062 13.4319 17.9062 13.6562V16.0938H20.3438C20.5681 16.0938 20.75 16.2756 20.75 16.5C20.75 16.7244 20.5681 16.9062 20.3438 16.9062H17.9062V19.3438C17.9062 19.5681 17.7244 19.75 17.5 19.75C17.2756 19.75 17.0938 19.5681 17.0938 19.3438V16.9062H14.6562C14.4319 16.9062 14.25 16.7244 14.25 16.5C14.25 16.2756 14.4319 16.0938 14.6562 16.0938H17.0938V13.6562C17.0938 13.4319 17.2756 13.25 17.5 13.25Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6112_100700",
    x: 0,
    y: 0,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6112_100700"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6112_100700",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddGrayTableIcon);
export default __webpack_public_path__ + "static/media/add-gray-table-icon.a387860c7bfe19e48c1f2b838fe55ac4.svg";
export { ForwardRef as ReactComponent };